"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.importColumnAliasExtraTargetColumnNames = void 0;
var importColumnAliasExtraTargetColumnNames;
(function (importColumnAliasExtraTargetColumnNames) {
    importColumnAliasExtraTargetColumnNames["EXTERNAL_PARTNER_ID"] = "externalPartnerId";
    importColumnAliasExtraTargetColumnNames["EXTERNAL_PARTNER_NAME"] = "externalPartnerName";
    importColumnAliasExtraTargetColumnNames["PARTNER_LOCATION"] = "partnerLocation";
    importColumnAliasExtraTargetColumnNames["PARTNER_ACT"] = "partnerAct";
    importColumnAliasExtraTargetColumnNames["SUBSCRIBER_ID"] = "subscriberId";
    importColumnAliasExtraTargetColumnNames["MEMBER_RELATIONSHIP"] = "memberRelationship";
    importColumnAliasExtraTargetColumnNames["EMPLOYMENT_STATUS"] = "employmentStatus";
    importColumnAliasExtraTargetColumnNames["MIDDLE_NAME"] = "middleName";
    importColumnAliasExtraTargetColumnNames["MEMBER_BENEFICIARY"] = "memberBeneficiary";
    importColumnAliasExtraTargetColumnNames["INSURANCE_NAME"] = "insuranceName";
    importColumnAliasExtraTargetColumnNames["INSURANCE_TYPE"] = "insuranceType";
    importColumnAliasExtraTargetColumnNames["INSURANCE_INDICATION"] = "insuranceIndication";
    importColumnAliasExtraTargetColumnNames["POLICY_ID"] = "policyId";
    importColumnAliasExtraTargetColumnNames["PATIENT_CONDITION_ADDITIONAL_INFO"] = "patientConditionAdditionalInfo";
})(importColumnAliasExtraTargetColumnNames || (exports.importColumnAliasExtraTargetColumnNames = importColumnAliasExtraTargetColumnNames = {}));
